import type { PropsWithChildren, ReactNode } from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { TooltipTrigger } from '../../../../Provider/TooltipManager.js'

export interface IFormControlProps extends PropsWithChildren {
  className?: string
  tooltip?: ReactNode
}

export const FormControl = ({ children, tooltip }: IFormControlProps) => {
  return (
    <div className="p-2 w-full flex flex-row gap-2">
      <div className="grow flex-row flex-wrap">{children}</div>
      {tooltip && (
        <div className="flex align-bottom items-end">
          <TooltipTrigger tooltip={tooltip}>
            <InformationCircleIcon type="information-circle-icon" className="h-8 w-8" />
          </TooltipTrigger>
        </div>
      )}
    </div>
  )
}
